module.exports = "<router-outlet>\r\n  <app-spinner><app-title></app-title></app-spinner>\r\n</router-outlet>\r\n"